import { render } from "./Activators.vue?vue&type=template&id=9175936c"
import script from "./Activators.vue?vue&type=script&lang=ts"
export * from "./Activators.vue?vue&type=script&lang=ts"
script.render = render

export default script